import CSS from 'csstype';

export const sourceStyle: CSS.Properties = {
    marginTop: 0,
    fontSize: '2vmin',
    fontFamily: "'Quicksand', sans-serif",
    opacity: 0.6
};

export const newsStyle: CSS.Properties = {
    width: '65%',
    fontFamily: "'Playfair Display', serif"
};

export const newsBlockStyle: CSS.Properties = {
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-12vmin'
}